import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './Services.module.scss';

Services.propTypes = {
  services: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default function Services({ services }) {
  return (
    <ul className={styles.root}>
      {services.map(service => (
        <li key={service.id} className={styles.item}>
          <Link className={styles.link} to={`/services/${service.slug}`}>
            <div className={styles.image}>
              <div style={{ backgroundImage: `url(${service.image.file.url})` }} />
            </div>
            <h3 className={styles.title}>{service.title}</h3>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: service.content.childMarkdownRemark.html.match(/^<p>(.+?)<\/p>/)[1] }}
            />
          </Link>
        </li>
      ))}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/Services.js